<template>
	<div class="pContent">
		<el-row :gutter="20">
			<el-col :span="14">
				<div class="list">
					<div class="listSum">推广内容列表（共{{ this.datalength }}个）</div>
					<div class="srcolldiv">
						<el-row
							class="itemDIV"
							:class="[{ bg: activeItem == index }]"
							v-for="(item, index) in data"
							:key="index"
							@click.native="prdItemHandle(item, index)"
						>
							<el-col :span="9"
								><div class="title">{{ item.title }}</div></el-col
							>
							<el-col :span="4"
								><div class="link" @click="dialogShow(item, '1')">广告标题</div></el-col
							>
							<el-col :span="4"
								><div class="link" @click="dialogShow(item, '2')">广告说明语</div></el-col
							>
							<el-col :span="3"
								><div class="link" @click="dialogShow(item, '3')">关键字</div></el-col
							>
							<el-col :span="4"><div class="link" @click="toSkip(item.pagePath)">查看落地页</div></el-col>
						
						</el-row>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div>
					<preview v-bind="prdItemData"></preview>
				</div>
			</el-col>
		</el-row>
		<el-dialog
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="40%"
			custom-class="tabDialog"
		>
		<el-tabs v-model="activeName">
			<el-tab-pane label="广告标题" name="1">
				<div class="srcolldiv">
					<div v-for="(item, index) in productTitle" :key="index" class="line">
						{{ item.content }}
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="广告说明语" name="2">
				<div class="srcolldiv">
					<div v-for="(item, index) in productExplain" :key="index" class="line">
						{{ item.content }}
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="关键词" name="3">
				<el-row class="keywordTitle">
					<el-col :span="12">关键词</el-col>
					<el-col :span="6">平均每月搜索量</el-col>
					<el-col :span="6">竞争程度</el-col>
				</el-row>
				<div class="srcolldiv">
					<el-row v-for="(item, index) in keyWords" :key="index" class="line">
						<el-col :span="12"
							><div :class="[{ linkHover: item.keywordLink }, 'link-box']">
								<ig-icon
									v-if="item.keywordLink"
									name="lianjie"
									class="keywordLink"
									@click.native="toSkip(item.keywordLink)"
								></ig-icon>
								<div>
									{{ item.keyword }}
								</div>
							</div>
						</el-col>
						<el-col :span="6"
							><div>{{ item.searchNum || '-' }}</div></el-col
						>
						<el-col :span="6"
							><div>{{ item.compete || '-' }}</div></el-col
						>
					</el-row>
				</div>
			</el-tab-pane>
		</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
import preview from './prd-preview';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: ['data'],
	data() {
		return {
			activeName: 1,
			dialogVisible: false,
			column: [
				{
					label: '',
					bind: 'imgPath',
				},
				{
					label: '',
					bind: 'imgPath',
				},
			],
			productTitle: [],
			productExplain: [],
			keyWords: [],
			prdItemData: {},
			activeItem: -1,
			dialogTitle: '',
		};
	},
	components: { preview },

	computed: {
		datalength() {
			return this.data ? this.data.length : 0;
		},
		id(){
			return this.$route.query.id;
		}
	},
	watch: {
		data: {
			handler(val) {
				this.activeItem = 0;
				this.prdItemData = val && val.length ? val[0] : {};
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		prdItemHandle(item, index) {
			// this.productdetail(item);
			this.productkeyword(item);
			this.prdItemData = item;
			this.activeItem = index;
		},
		dialogShow(item, activeName) {
			this.dialogTitle = item.title;
			this.activeName = activeName;
			this.dialogVisible = true;
			this.productTitle = item.adTitleList;
			this.productExplain = item.adExplainList;
			// this.productdetail(item);
			this.productkeyword(item);
		},
		// async productdetail(item) {
		// 	let res = await adsNewOnlineSer.productdetail({
		// 		automationContentId: item.automationContentId,
		// 		automationId: id,
		// 	});
		// 	this.productTitle = res.data.adTitleList;
		// 	this.productExplain = res.data.adExplainList;
		// },

		async productkeyword(item) {
			let res = await adsNewOnlineSer.productkeyword({
				automationContentId: item.automationContentId,
				automationId: this.id,
			});
			this.keyWords = res.data.allKeywordList;
		},
		toSkip(item) {
			//pagePath
			window.open(item);
		},
	},
};
</script>

<style lang="scss" scoped>
.pContent {
	padding: 10px 20px 20px 30px;
	.list {
	}
	.listSum {
		display: flex;
		padding-left: 30px;
		text-align: center;
		line-height: 54px;
		height: 54px;
		background: #fafafa;
		border-bottom: 1px #e8e8e8 solid;
	}
	.itemDIV {
		display: flex;
		justify-content: space-around;
		align-items: center;
		min-height: 60px;
		border-bottom: 1px #e8e8e8 solid;
		.title {
			cursor: pointer;
			color: #333333;
			text-align: left;
			padding-left: 10px;
		}
		.link {
			cursor: pointer;
			color: #3da1ff;
			text-align: center;
		}
	}
	// .itemDIV:hover {
	// 	background: rgba(0, 0, 0, 0.15);
	// }
	.bg {
		background: #ebf5ff;
	}
	::v-deep  .tabDialog {
		.el-dialog__body {
			padding: 10px 30px 50px 30px !important;
		}
	}
	.line {
		padding: 15px 0px;
		text-align: left;
		border-bottom: 1px #e8e8e8 solid;
	}
	.srcolldiv {
		max-height: 350px;
		overflow-x: hidden;
		overflow-y: scroll;
	}
	/*滚动条样式*/
	.srcolldiv::-webkit-scrollbar {
		position: relative;
		width: 6px;
	}
	.srcolldiv::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
		background: rgba(163, 155, 155, 0.2);
	}
	.srcolldiv::-webkit-scrollbar-track {
		/* box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3); */
		border-radius: 0;
		/* background: rgba(193, 185, 185, 0.1); */
	}
	.keywordTitle {
		background: #eaeaea;
		border-radius: 2px;
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		padding: 10px;
	}
	.keywordLink {
		color: #3da1ff;
		margin-right: 5px;
		cursor: pointer;
	}
	.link-box {
		display: flex;
		padding-left: 10px;
	}
	.linkHover:hover {
		color: #3da1ff;
	}
}
</style>
